import { normalizeFavouriteBaseKey } from 'utils/favouritesStorage';

export function surveyCoverageFavouriteTwinKeys(
  layerKey: string,
): readonly [string, string] {
  const baseKey = normalizeFavouriteBaseKey(layerKey);
  return [baseKey, `favourites_${baseKey}`];
}


 // keep Legend favourite checkboxes in sync with Survey Image Viewer coverage
 // check state (and the reverse).
 
export function syncSurveyCoverageFavouriteCheckedKeys(
  checkedKeys: readonly string[],
  layerKey: string,
  checked: boolean,
): string[] {
  const next = new Set(checkedKeys.map(String));
  const twins = surveyCoverageFavouriteTwinKeys(layerKey);
  if (checked) {
    for (const key of twins) {
      next.add(key);
    }
  } else {
    for (const key of twins) {
      next.delete(key);
    }
  }
  return [...next];
}
